import axios from '../Api/axios';
import useAuth from './useAuth';

const useRefreshToken = () => {
  const { setAuth } = useAuth();

  const refresh = async () => {
    const response = await axios.get('/refresh', {
      withCredentials: true,
    });
    setAuth((prev) => ({
      ...prev,
      accessToken: response.data.accessToken,
      email: response.data.email,
      roles: response.data.roles,
      name: response.data.name,
      surname: response.data.surname,
      phone: response.data.phone,
      company: response.data.company,
      handle: response.data.handle,
      social: response.data.social,
      wallet: response.data.wallet,
      verified: response.data.verified,
    }));
    return response.data.accessToken;
  };
  return refresh;
};

export default useRefreshToken;
